/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CardCategory = {
    STANDARD: 'STANDARD',
    DEPARTMENT: 'DEPARTMENT',
    SUBSCRIPTION: 'SUBSCRIPTION',
    TRAVEL: 'TRAVEL'
} as const;

export type CardCategory = typeof CardCategory[keyof typeof CardCategory];



